import { ColumnDef } from "@tanstack/react-table";
import { Typography } from "@/core/components/ui/typography";
import { formatMoney } from "@/core/utils/money";

interface WithSpiffAmount {
  amount: number;
}

const SpiffPaymentAmountCol = <T extends WithSpiffAmount>(): ColumnDef<T> => ({
  header: "Payment",
  accessorFn: (row) => row.amount,
  cell: ({ row }) => (
    <Typography variant="bodyW1">{formatMoney(row.original.amount)}</Typography>
  ),
});

export default SpiffPaymentAmountCol;
